<template>
    <SearchDialog
        :context="context"
        :searchcontext="'ContractsFor' + context"
        subcontext="Contracts"
        :addcontext="'ContractsTo' + context"
        addButtonLabel="lang_PUBLISHING_WORKS_ADD_CONTRACTS_DIALOG_TITLE"
        dialogTitle="lang_PUBLISHING_WORKS_ADD_CONTRACTS_DIALOG_TITLE"
        :alvqaContext="alvqa + '-list'"
    >
        <template v-slot:itemTitle="{ item }">
            {{ item.contractName }} ({{ item.alvId }})
        </template>
        <template v-slot:itemSubtitle="{ item }">
            {{ item.licensor !== null ? item.licensor.gemaName : '' }}
        </template>
    </SearchDialog>
</template>
 
<script>
import SearchDialog from '@/components/_dialogs/SearchDialog'

export default {
    name: "TracksSearchContractsDialog",
    components: {
        SearchDialog
    },
    data() {
        return {
            context: "Tracks",
            alvqa: "label-tracks"
        }
    }
}
</script>